import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import VueMeta from "vue-meta";
import css from "./css/style.scss";
import Editor from "@tinymce/tinymce-vue";
import VueGtag from "vue-gtag";
Vue.config.productionTip = false;
Vue.use(VueMeta);
Vue.use(
  VueGtag,
  {
    config: { id: "G-C7W2HFXLPX" },
  },
  router
);
new Vue({
  router,
  css,
  components: {
    editor: Editor,
  },
  render: (h) => h(App),
}).$mount("#app");
